module.exports = __webpack_public_path__ + "static/media/cloud.8f70c0b4.png";